import { ConfirmationActions, RegistrantTypes, SearchMeditatorActions, TableTitles } from "@/constants";
import { useGetMeditationRetreatDetail } from "@/hooks/query-hooks/useMeditationRetreats";
import { useGetMeditatorsByMeditationRetreat } from "@/hooks/query-hooks/useMeditators";
import { useState } from "react";
import { useParams } from "react-router";
import { AnimatedComponent } from "../common";
import { ManualRegisterMeditator } from "./ManualRegisterMeditator";
import { MeditatorFilter } from "./MeditatorFilter";
import { RegistrantDetailDrawer } from "./RegistrantDetailDrawer";
import { RegistrantDetailHeader } from "./RegistrantDetailHeader";
import { RegistrantTable } from "./RegistrantTable";

export function NewRegistrants() {

    const { retreatId } = useParams<{ retreatId: string }>();
    const { data: retreatData, isLoading: isLoadingMeditationRetreat } = useGetMeditationRetreatDetail(retreatId!);

    const [page, setPage] = useState(1);
    const { data: meditatorData, isLoading: isLoadingMeditators } = useGetMeditatorsByMeditationRetreat(retreatId!, page, "PENDING");

    const meditators = meditatorData?.content || [];

    const registrantRenderColumnsKey = [
        TableTitles.registrant_name,
        TableTitles.registrant_book_id,
        TableTitles.registrant_phone,
        TableTitles.registrant_nrc,
        TableTitles.registrant_address,
        TableTitles.action
    ]

    return (
        <AnimatedComponent className="!space-y-6">

            <MeditatorFilter
                defaultActiveTab={"new_registrants"}
            />

            <RegistrantDetailHeader
                redirectTab={"new_registrants"}
                retreatData={retreatData ? [retreatData] : []}
                loading={isLoadingMeditationRetreat}
            />

            <div
                className="space-y-4"
            >
                <article
                    className="flex items-center justify-between"
                >
                    <h2
                        className="text-base font-semibold"
                    >
                        စာရင်းသွင်းထားသောယောဂီများ
                    </h2>
                    <ManualRegisterMeditator
                        registrantType={RegistrantTypes.NEW}
                        meditationEventId={retreatId}
                        modalType={SearchMeditatorActions.REGISTERATION}
                    />
                </article>
                <RegistrantTable
                    renderColumnKeys={registrantRenderColumnsKey}
                    TableActionComponent={TableActionComponent}
                    dataSource={meditators}
                    loading={isLoadingMeditators}
                    pagination={{
                        current: page,
                        total: meditatorData?.totalElements || 0,
                        onChange: (page) => setPage(page),
                    }}
                />
            </div>
        </AnimatedComponent>
    )
}

const TableActionComponent = ({ record }: { record: MeditatorWithMeditationRetreat }) => {
    return (
        <RegistrantDetailDrawer
            registrant={record}
            confirmationAction={ConfirmationActions.ACCEPT}
            drawerType={SearchMeditatorActions.REGISTERATION}
        />
    )
}